import { useState } from 'react';
import { Button, Card, Stack, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

import InputSearch from 'components/v2/input/InputSearch';
import { useLocalization } from 'localization';
import { CheckIcon } from 'components/v2/icons/CheckIcon';
import DateLocalizationProvider from 'components/v2/date/DateLocalizationProvider';
import { ArrowRightIcon } from 'components/v2/icons/ArrowRightIcon';
import { colors } from 'theme/mui/colors';
import { createAdsCampaignOrderStore } from 'stores/createAdsCampaignOrderStore';

export const mockPackages = [
  {
    id: 'pkg-basic',
    name: 'EFKT Property Basic',
    description:
      'An affordable entry-level plan designed for small property owners who need simple listing and basic management features.',
    benefits: ['List up to 10 properties', 'Email support during business hours', 'Access to standard reporting tools'],
    startDate: '2025-01-01',
    type: 'basic',
  },
  {
    id: 'pkg-premium',
    name: 'EFKT Property Premium',
    description:
      'A complete solution for professional agencies with extended listings, advanced insights, and faster support.',
    benefits: [
      'Unlimited property listings',
      'Priority phone & email support',
      'Advanced analytics and performance dashboards',
    ],
    startDate: '2025-01-01',
    type: 'premium',
  },
  {
    id: 'pkg-pro',
    name: 'EFKT Property Pro',
    description:
      'The ultimate package for large organizations that need enterprise-level scalability, custom features, and dedicated support.',
    benefits: [
      'Custom integrations with your CRM and ERP',
      'Dedicated account manager and 24/7 support',
      'AI-powered property recommendations and automation',
    ],
    startDate: '2025-01-01',
    type: 'pro',
  },
];

const CreateAdsCampaignOrderStep2 = () => {
  const { t } = useLocalization();
  const [textSearch, setTextSearch] = useState('');
  const { goToStep } = createAdsCampaignOrderStore();

  return (
    <Stack direction="column" gap={2} sx={{ margin: '2rem 1rem 1rem 0' }}>
      <Typography variant="h3">{t('common.actions.choosePackage')}</Typography>
      <Typography variant="body1">{t('common.terms.searchForPackages')}</Typography>

      <Stack direction="row" justifyContent="flex-end">
        <InputSearch
          onSearch={val => setTextSearch(val)}
          placeholder={t('common.terms.searchForPackages')}
          sx={{ width: { xs: '100%', sm: '40%' } }}
        />
      </Stack>

      {mockPackages.map((pkg, index) => {
        return (
          <Card sx={{ display: 'flex', flexDirection: 'row' }} key={index}>
            <Stack flex={1} gap={1.5}>
              <Stack gap={0.75}>
                <Typography variant="h4">{pkg.name}</Typography>
                <Typography variant="body1">{pkg.description}</Typography>
              </Stack>

              <Stack gap={1}>
                <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CheckIcon /> {pkg.benefits[0]}
                </Typography>
                <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CheckIcon /> {pkg.benefits[1]}
                </Typography>
                <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CheckIcon /> {pkg.benefits[2]}
                </Typography>
              </Stack>

              <Stack direction="row" gap={1}>
                <DateLocalizationProvider>
                  <DatePicker
                    label="01/01/2026"
                    slotProps={{
                      textField: {
                        size: 'small',
                      },
                    }}
                  />
                </DateLocalizationProvider>
                <Button variant="contained" size="medium" endIcon={<ArrowRightIcon />} onClick={() => goToStep(3)}>
                  {t('orders.pages.new.ads.continueWithPlan')}
                </Button>
              </Stack>
            </Stack>
            <Stack
              flex={0.5}
              sx={{
                backgroundImage: 'url(/img/package_plan.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '1rem',
                borderRadius: '0.5rem',
              }}
              justifyContent="space-between"
            >
              <Stack justifyContent="center" alignItems="center" gap={2.5}>
                <Typography variant="body2">Running for 14 days</Typography>
                <Typography variant="h3">14000 DKK</Typography>
              </Stack>

              <Stack direction="row" gap={1} justifyContent="space-between">
                <Card sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flex: 1 }}>
                  <Typography variant="h6" sx={{ color: colors.base.level70 }}>
                    Display
                  </Typography>
                  <Typography variant="h6" sx={{ color: colors.base.level60 }}>
                    25%
                  </Typography>
                </Card>
                <Card sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flex: 1 }}>
                  <Typography variant="h6" sx={{ color: colors.base.level70 }}>
                    SoMe
                  </Typography>
                  <Typography variant="h6" sx={{ color: colors.base.level60 }}>
                    75%
                  </Typography>
                </Card>
              </Stack>
            </Stack>
          </Card>
        );
      })}
    </Stack>
  );
};

export default CreateAdsCampaignOrderStep2;
